/**
 * Size guide v2: CM ↔ INCH for measurement tables; model / fit: cm+kg ↔ ft′in″+lbs.
 */
(function () {
  function parseNum(s) {
    if (s == null || s === '') return NaN;
    var t = String(s).trim().replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(t)) return NaN;
    return parseFloat(t, 10);
  }

  function fmt(n, unit) {
    if (!Number.isFinite(n)) return '';
    if (unit === 'INCH') {
      var inch = n / 2.54;
      var ri = Math.round(inch * 10) / 10;
      return String(ri).replace(/\.0$/, '');
    }
    var rc = Math.round(n * 10) / 10;
    return String(rc).replace(/\.0$/, '');
  }

  function fmtHeightFtIn(cm) {
    if (!Number.isFinite(cm)) return '';
    var totalIn = cm / 2.54;
    var ft = Math.floor(totalIn / 12);
    var inch = Math.round(totalIn - ft * 12);
    if (inch >= 12) {
      ft += 1;
      inch -= 12;
    }
    if (inch < 0) inch = 0;
    return ft + '\u2032' + inch + '\u2033';
  }

  function fmtWeightFromKg(kg, unit) {
    if (!Number.isFinite(kg)) return '';
    if (unit === 'INCH') {
      var lb = kg * 2.2046226218;
      var r = Math.round(lb * 10) / 10;
      return String(r).replace(/\.0$/, '');
    }
    var r = Math.round(kg * 10) / 10;
    return String(r).replace(/\.0$/, '');
  }

  function cellCm(td, store) {
    var raw = parseNum(td.textContent);
    if (!Number.isFinite(raw)) return null;
    return store === 'INCH' ? raw * 2.54 : raw;
  }

  function initTable(table) {
    var store = (table.getAttribute('data-sgv2-store-unit') || 'CM').toUpperCase();
    var tbody = table.querySelector('tbody');
    if (!tbody) return store;
    tbody.querySelectorAll('td').forEach(function (td) {
      var cm = cellCm(td, store);
      if (cm != null) td.dataset.sgv2Cm = String(cm);
    });
    return store;
  }

  function apply(host, unit) {
    host.querySelectorAll('table[data-sgv2-measure-table] tbody td').forEach(function (td) {
      if (td.dataset.sgv2Cm === undefined) return;
      var cm = parseFloat(td.dataset.sgv2Cm, 10);
      td.textContent = fmt(cm, unit);
    });

    host.querySelectorAll('.js-sgv2-fit-height').forEach(function (el) {
      var cm = parseFloat(el.dataset.sgv2Cm, 10);
      if (!Number.isFinite(cm)) return;
      if (unit === 'INCH') {
        el.textContent = fmtHeightFtIn(cm);
      } else {
        el.textContent = fmt(cm, 'CM');
      }
      var sib = el.nextElementSibling;
      if (sib && sib.classList.contains('js-sgv2-fit-height-suffix')) {
        sib.textContent = unit === 'INCH' ? '' : 'cm';
      }
    });

    host.querySelectorAll('.js-sgv2-fit-weight').forEach(function (el) {
      var kg = parseFloat(el.dataset.sgv2Kg, 10);
      if (!Number.isFinite(kg)) return;
      el.textContent = fmtWeightFromKg(kg, unit);
      var sib = el.nextElementSibling;
      if (sib && sib.classList.contains('js-sgv2-weight-suffix')) {
        sib.textContent = unit === 'INCH' ? 'lbs' : 'kg';
      }
    });

    host.querySelectorAll('[data-sgv2-cm]').forEach(function (el) {
      if (el.classList.contains('js-sgv2-fit-height')) return;
      var cm = parseFloat(el.dataset.sgv2Cm, 10);
      if (!Number.isFinite(cm)) return;
      el.textContent = fmt(cm, unit);
    });

    host.querySelectorAll('.js-sgv2-unit-suffix').forEach(function (el) {
      el.textContent = unit === 'INCH' ? 'in' : 'cm';
    });

    host.querySelectorAll('[data-sgv2-unit-btn]').forEach(function (b) {
      var on = b.getAttribute('data-sgv2-unit-btn') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

  }

  function bind(host) {
    var tables = host.querySelectorAll('table[data-sgv2-measure-table]');
    var store = 'CM';
    if (tables.length) {
      tables.forEach(function (t) {
        initTable(t);
      });
      store = (tables[0].getAttribute('data-sgv2-store-unit') || 'CM').toUpperCase();
    } else {
      var su = host.querySelector('[data-sgv2-store-unit]');
      if (su) store = (su.getAttribute('data-sgv2-store-unit') || 'CM').toUpperCase();
    }
    var hasFit = host.querySelector('.size-guide-v2__fit-cards');
    if (!tables.length && !hasFit) return;

    var bar = host.querySelector('.size-guide-v2__unit-toggle');
    if (!bar) {
      apply(host, store);
      return;
    }
    bar.addEventListener('click', function (e) {
      e.stopPropagation();
      var btn = e.target.closest('[data-sgv2-unit-btn]');
      if (!btn) return;
      e.preventDefault();
      apply(host, btn.getAttribute('data-sgv2-unit-btn'));
    });
    apply(host, store);
  }

  function run() {
    document.querySelectorAll('coretex-dialog.size-guide-v2-dialog').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
